import {
  Component,
  EventEmitter,
  ViewChild,
  Input,
  OnInit,
  Renderer2,
  Output
} from '@angular/core';
import {DateRangeFormatter } from './date-range-picker.formatter';
import { Subject } from 'rxjs';

@Component({
  selector: 'date-range-picker-template',
  templateUrl: './date-range-picker.template.component.html',
  host: { class: 'axis-daterange-picker' }
})
export class DateRangePickerTemplateComponent implements OnInit {
  protected dateFormatter: DateRangeFormatter = new DateRangeFormatter();
  public inputValue = '';
  public items =
    [
      'Custom',
      'Today',
      'Yesterday',
      'This Week',
      'This Month',
      'Last Month',
      'This Year',
      'Last Year'
    ];
  public selectedList = 'Custom';
  @Input() public customFormat = 'MMM DD, YYYY';
  @Output()
  public selectionDone: EventEmitter<any> = new EventEmitter<any>(undefined);
  @Input() leftModelDate;
  @Input() rightModelDate;

  @Input() startDate;
  @Input() endDate;
  @ViewChild('leftCalendar') leftCalendar: any;
  @ViewChild('rightCalendar') rightCalendar: any;
  public removeTemplate: Subject<string> = new Subject();
  @ViewChild('ulElement') ulElement: any;
  private unbindKeyEvent: Function;
  @Input()  datepickerMode;

  private keys: Array<string> = [
    'arrowdown',
    'arrowup',
    'enter',
    'keya',
    'keyx',
    'keyc',
    'escape'
  ];
  constructor(private renderer:Renderer2) {}
  ngOnInit() {
    this.checkPreSelection();
    if (this.datepickerMode === 'month') {
      this.items.splice(1, 3);
    }
  }
  ngAfterViewInit() {
    this.keyDownEvent();
  }
  listArrowUp(event) {
    const focusableLi = this.ulElement.nativeElement.querySelectorAll('li');
    const id = parseInt(this.ulElement.nativeElement.querySelectorAll('li.active')[0].id, 10);
    if (focusableLi[id].previousElementSibling) {
      focusableLi[id].previousElementSibling.click();
    }
  }

  listArrowDown(event) {
    const focusableLi = this.ulElement.nativeElement.querySelectorAll('li');
    const id = parseInt(this.ulElement.nativeElement.querySelectorAll('li.active')[0].id, 10);
    if (focusableLi[id].nextElementSibling) {
      focusableLi[id].nextElementSibling.click();
    }
  }

 /**
    * Key events for the calendar.
    * ESCAPE: moves focus ton input and close the calendar.
    * UP_ARROW: Go to the previous quick bar selection.
    * DOWN_ARROW: Go to the next quick bar selection.
    * CTRL+ ALT + A:select the apply button
    * CTRL+ ALT + X:select the cancel button
    * CTRL+ ALT + C:select the clear button

    * @param event as KeyboardEvent
    */
  keyDownEvent() {
    this.unbindKeyEvent = this.renderer.listen(
      document,
      'keydown',
      (event: KeyboardEvent) => {
        const keyCode = event.code.toLowerCase();
        if (this.keys.indexOf(keyCode) > -1) {
          event.preventDefault();
          switch (keyCode) {
            case 'escape':
              this.removeTemplate.next('remove');
              this.unbindEvent();
              break;

            case 'keya':
              if (event.ctrlKey === true && event.altKey === true) {
                this.apply();
              }
              break;
            case 'keyx':
              if (event.ctrlKey === true && event.altKey === true) {
                this.cancel();
              }
              break;
            case 'keyc':
              if (event.ctrlKey === true && event.altKey === true) {
                this.clear();
              }
              break;
          }
        }
      });
  }

/**
 * api method called on onload .
 */
  preSelectData(customFormat, inputValue, startDate, endDate) {
    this.customFormat = customFormat;
    this.inputValue = inputValue;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  /**
  *  method called for instant calendars on click of template .
  */
  instantCalendars(startDate: any, endDate: any) {
    this.leftCalendar.setSelectionDates(startDate, startDate, endDate);
    this.rightCalendar.setSelectionDates(startDate, endDate, endDate);
    if (this.datepickerMode === 'day') {
      if (new Date(startDate).getMonth() === new Date(endDate).getMonth()) {
        this.rightCalendar.moveDirection(1);
      }
    } else if (this.datepickerMode === 'month') {
      if (new Date(startDate).getFullYear() === new Date(endDate).getFullYear()) {
        this.rightCalendar.moveDirection(1);
      }
    }
  }
  /**
  *  preSelection method called at on load to change calendars to default position .
  */
  checkPreSelection() {
    const date = new Date();
    if (this.inputValue === '') {
      this.leftModelDate = date;
      if (this.datepickerMode === 'day') {
        this.rightModelDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      } else if (this.datepickerMode === 'month') {
        this.rightModelDate = new Date(date.getFullYear() + 1, date.getMonth(), 1);
      }
    } else {
      this.leftModelDate = this.startDate;
      if (this.datepickerMode === 'day') {
      if (this.startDate.getMonth() === this.endDate.getMonth()) {
        const nextMonthDate = new Date(this.startDate.getFullYear(),
          this.startDate.getMonth() + 1, 1);
        this.rightModelDate = nextMonthDate;
      } else {
        this.rightModelDate = this.endDate;
      }
    } else if (this.datepickerMode === 'month') {
      if (this.startDate.getFullYear() === this.endDate.getFullYear()) {
        const nextYear = new Date(this.startDate.getFullYear()+1,
          this.startDate.getMonth(), 1);
        this.rightModelDate = nextYear;
      } else {
        this.rightModelDate = this.endDate;
      }
    }
    }
  }
  /**
   *  resetData method called to reset to default values .
   */
  resetData() {
    const date = new Date();
    if(this.leftCalendar && this.rightCalendar) {
      this.leftCalendar.resetSelection(date);
      if(this.datepickerMode === 'day') {
      this.rightCalendar.resetSelection(new Date(date.getFullYear(), date.getMonth() + 1, 1));
      } else if(this.datepickerMode === 'month') {
        this.rightCalendar.resetSelection(new Date(date.getFullYear()+1,
        date.getMonth(), 1));
      }
    }
    this.resetInputSelection();
  }
  /**
 *  selectedLeftDate method called on selection of left calendar date .
 */
  selectedLeftDate(event) {
    this.rightCalendar.selectedRangeDate(event.startDate, event.endDate);
    this.startDate = event.startDate;
    if (event.endDate) {
      this.endDate = event.endDate;
    } else {
      this.endDate = event.startDate;
    }
  }
  /**
  *  selectedLeftDate method called on selection of right calendar date .
  */
  selectedRightDate(event) {
    this.leftCalendar.selectedRangeDate(event.startDate, event.endDate);
    this.startDate = event.startDate;
    if (event.endDate) {
      this.endDate = event.endDate;
    } else {
      this.endDate = event.startDate;
    }
  }
 
  emitDates(inputValue, startDate, endDate) {
    this.selectionDone.emit({
      'inputValue': inputValue,
      'startDate': startDate,
      'endDate': endDate
    });
  }
  clear() {
    this.resetData();
    this.emitDates('', null, null);
  }
  resetInputSelection() {
    this.startDate = '';
    this.endDate = '';
    this.inputValue = '';    
  }
  cancel() {
    if (this.inputValue === '') {
      this.resetInputSelection();
      this.emitDates(this.inputValue, this.startDate, this.endDate);
    }
    this.removeTemplate.next('remove');
    this.unbindEvent();
  }

  apply() {
    if (this.startDate && this.endDate) {
      this.inputValue = this.formattedDates(this.startDate, this.endDate);
      this.emitDates(this.inputValue, this.startDate, this.endDate);
    } else {
      this.resetInputSelection();
      this.emitDates('', null, null);
    }
    this.removeTemplate.next('remove');
    this.unbindEvent();
  }

  unbindEvent() {
    if (typeof this.unbindKeyEvent === 'function') {
      this.unbindKeyEvent();
    }
  }
  /**
  *  onSelect method called on selection of template .
  */
  onSelect(data) {
    this.selectedList = data;
    if (data === 'Custom') {
      this.resetData();
      this.emitDates('', null, null);
    } else {
        this.inputValue = this.getSelection(data);
        this.startDate = this.dateFormatter.fixTimeZone(new Date(this.startDate));
        this.endDate = this.dateFormatter.fixTimeZone(new Date(this.endDate));
        this.instantCalendars(this.startDate, this.endDate);
        this.emitDates(this.inputValue, this.startDate, this.endDate);
    }
  }

  getSelection(data) {
    const date = new Date();
    switch (data) {
      case 'Today':
        return this.today(date);
        break;
      case 'Yesterday':
        return this.yesterday(date);
        break;
      case 'This Week':
        return this.thisWeek(date);
        break;
      case 'This Month':
        return this.thisMonth(date);
        break;
      case 'Last Month':
        return this.lastMonth(date);
        break;
      case 'This Year':
        return this.thisYear(date);
        break;
      case 'Last Year':
        return this.lastYear(date);
        break;
    }
  }

  today(date) {
    this.startDate = date;
    this.endDate = date;
    return this.formattedDates(this.startDate, this.endDate);
  }

  yesterday(date) {
    const setDate = date.setDate(date.getDate() - 1);
    this.startDate = setDate;
    this.endDate = setDate;
    return this.formattedDates(this.startDate, this.endDate);
  }

  thisWeek(date) {
    this.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay());
    this.endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 6);
    return this.formattedDates(this.startDate, this.endDate);
  }
  thisMonth(date) {
    this.startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return this.formattedDates(this.startDate, this.endDate);
  }

  lastMonth(date) {
    this.startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    this.endDate = new Date(date.getFullYear(), date.getMonth(), 0);
    return this.formattedDates(this.startDate, this.endDate);
  }
  thisYear(date) {
    this.startDate = new Date(date.getFullYear(), 0, 1);
    this.endDate = new Date(date.getFullYear(), 11, 31);
    return this.formattedDates(this.startDate, this.endDate);
  }
  lastYear(date) {
    this.startDate = new Date(date.getFullYear() - 1, 0, 1);
    this.endDate = new Date(date.getFullYear() - 1, 11, 31);
    return this.formattedDates(this.startDate, this.endDate);
  }

  formattedDates(startDate, endDate) {
    const inputStartDate = this.dateFormatter.format(startDate, this.customFormat);
    const inputEndDate = this.dateFormatter.format(endDate, this.customFormat);
    return inputStartDate + ' ' + '-' + ' ' + inputEndDate;
  }
}
